import * as PapaParse from 'papaparse';
import handleFileDownload from '../handleFileDownload';

/**
 * A helper function to export data from analytics tables
 *
 * @param {Array} tableConfig The table contents.
 * @param {string} prefix The desired prefix of the file.
 * @param {string} sectionTitle The table title.
 * @returns {void}
 */
const exportAnalyticsData = async (tableConfig, prefix, sectionTitle) => {
  const csvContents = tableConfig.tableData.map(data => {
    let content = {};

    tableConfig.tableColumns.forEach(column => {
      let dataValue = data[column.dataIndex];

      // Check for cases where content is a link
      if (column.link && data.id) {
        dataValue = `${data[column.dataIndex]} (${data.id})`;
      }

      content[column.title] = dataValue;
    });

    return content;
  });

  const csv = PapaParse.unparse(csvContents);
  const csvData = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
  const fileName = `${prefix}_${sectionTitle.toLowerCase().replace(/\s+/g, '_')}.csv`;
  handleFileDownload(csvData, fileName);
};

export default exportAnalyticsData;
